import { createContext, useContext } from "react";
import { z } from "zod";

const FormSchemaContext = createContext<z.ZodObject<any> | undefined>(undefined);

export const FormSchemaProvider = FormSchemaContext.Provider;

export const useFormSchema = () => useContext(FormSchemaContext);
